import styled from 'styled-components';

export const DesktopSidebarWithSnowflakeWrapper = styled('aside')`
  position: fixed;
  width: ${({ theme }) => theme.sidebarWidth}px;
  margin-left: -290px;
  padding: ${({ theme }) =>
    `${theme.x1spacePx}px ${theme.x3spacePx}px 0 ${theme.x2space * 10}px`};
`;

export const SnowflakeWrapper = styled('div')`
  margin: 0 -${({ theme }) => theme.x1spacePx}px;
  max-width: 160px;
`;

export const ActionsWrapper = styled('div')`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  margin-bottom: -${({ theme }) => theme.x1spacePx}px;
`;

export const SidebarWrapper = styled('div')`
  margin-left: -${({ theme }) => theme.x3spacePx}px;
`;

export const Title = styled('p')`
  margin: ${({ theme }) => theme.x2spacePx}px 0 0;
`;

export const SubTitle = styled('p')`
  margin: 0;
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
`;
